<template>
  <div class="display">
    <!-- Chargement -->
    <div v-if="loadingMessages" class="text-xs-center targetFirst_loading">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <v-layout v-if="userRights == 1" row wrap class="layoutTraficVisiteurs bigChat">
      <!-- affiche uniquement mes messages en attente -->
        <v-flex
          v-if="
            (!dataVisiteurComputed.visiteurID && $vuetify.breakpoint.xsOnly) ||
           !$vuetify.breakpoint.xsOnly
          "
          xs12 :class="{sm3: dataMessageSelected}" class="traficListVisiteurs fill-height">
          <v-card class="cardTraficVisiteurs">
            <v-card-title>
              <!-- menu classement -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :loading="loadingMessages"
                    :disabled="loadingMessages"
                    color="primary"
                    class="white--text"
                    v-on="on"
                  >
                    <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('ranking')|cap}}</span>
                    <v-icon 
                      v-if="typeClassement == 'new'"
                      :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                      dark
                    >flip_to_front</v-icon>
                    <v-icon 
                      v-else-if="typeClassement == 'old'"
                      :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                      dark
                    >flip_to_back</v-icon>
                  </v-btn>
                </template>
                
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in itemsClassementPeon"
                    :key="index"
                    @click="getMessagesAgents(listeAgentId, item.type)"
                  >
                    <v-list-tile-title>
                      
                      <v-icon 
                        :left="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                      >{{item.icone}}</v-icon>
                      <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{item.title}}</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-card-text>
               <v-subheader>{{$tc('messageAttente', maListeMessagesAttente.length, {count: maListeMessagesAttente.length})}}</v-subheader>
              <v-list two-line dense class="listeTraficVisiteurs">
                
                  <div class="wz_wrapChips" v-for="(messageAttente, i) in maListeMessagesAttente" :key="i">
                    <v-flex xs12 sm12
                      class="visiteurFiltrer"
                    >
                        <v-list-tile
                          :class="{ 'light-blue lighten-4': messageAttenteSelected.visiteurID == messageAttente.visiteurID,  }"
                          ripple
                          :key="messageAttente.status"
                          @click="openMessageVisiteur(myId, messageAttente)"
                        >
                          <v-list-tile-avatar>
                            <wz-avatar
                              v-if="messageAttente.network == 'moon' || !messageAttente.network"
                              :username="'#' + messageAttente.visiteurID"
                              size="38px"
                              class="pl-1"
                            ></wz-avatar>
                            <wz-avatar
                              v-else-if="messageAttente.network == 'facebook'"
                              :src="messageAttente.profile_pic"
                              :username="messageAttente.visiteurName"
                              size="38px"
                              class="pl-1"
                            ></wz-avatar>
                            <wz-avatar
                              v-else-if="messageAttente.network == 'whatsapp'"
                              :src="messageAttente.profile_pic"
                              :username="messageAttente.visiteurName"
                              size="38px"
                              class="pl-1"
                            ></wz-avatar>
                            <wz-avatar
                              v-else-if="!istypingVisiteur && messageAttente.message && messageAttente.visiteurID != messageAttenteSelected"
                              :username="'#' + messageAttente.visiteurID"
                              size="38px"
                              lastMessage
                            ></wz-avatar>
                            <wz-avatar
                              v-else-if="istypingVisiteur"
                              :isTyping="istypingVisiteur"
                              :username="'#' + messageAttente.visiteurID"
                              size="38px"
                              chip
                            ></wz-avatar>
                          </v-list-tile-avatar>
                          
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <div v-if="messageAttente.network == 'moon' || !messageAttente.network" class="wz_nameVisiteur">
                                {{messageAttente.visiteurID}} <span>({{dateMessageFromNow(messageAttente.timestamp)}})</span>
                              </div>
                              <div v-if="messageAttente.network == 'email'" class="wz_nameVisiteur">
                                {{messageAttente.visiteurID}} <span>({{dateMessageFromNow(messageAttente.timestamp)}})</span>
                              </div>
                              <div v-else-if="messageAttente.network == 'facebook'" class="wz_nameVisiteur">
                                {{messageAttente.visiteurName}} <span>({{dateMessageFromNow(messageAttente.timestamp)}})</span>
                              </div>
                              <div v-else-if="messageAttente.network == 'whatsapp'" class="wz_nameVisiteur">
                                {{messageAttente.visiteurName}} <span>({{dateMessageFromNow(messageAttente.timestamp)}})</span>
                              </div>
                            </v-list-tile-title>
                            <v-list-tile-sub-title v-if="messageAttente.message.length">
                                <div
                                  slot="activator"
                                  v-if="messageAttente.message.length"
                                  class="wz_alertFiltre"
                                >
                                  <v-icon v-if="messageAttente.network == 'moon' || !messageAttente.network" size="20" class="secondary--text text--lighten-1">chat_bubble</v-icon>
                                  <v-icon v-else-if="messageAttente.network == 'email'" size="20" class="blue-grey--text lighten-2">email</v-icon>
                                  <v-icon v-else-if="messageAttente.network == 'facebook'" size="20" color="blue accent-4--text" class=" ">mdi-facebook-messenger</v-icon> 
                                  <v-icon v-else-if="messageAttente.network == 'whatsapp'" size="20" color="green accent-4--text" class=" ">mdi-whatsapp</v-icon> 
                                <div class="d-inline">{{messageAttente.message[0]}}</div>
                                </div>
                              
                            </v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-btn flat slot="activator" icon color="accent"
                              @mouseover.native="overMenu = true"
                              @mouseleave.native="overMenu = false"
                              @click="suppMessage({
                                'messageId': messageAttente.messageId,
                                'agentId': messageAttente.agentId,
                                'visiteurId': messageAttente.visiteurID,
                                'message': messageAttente.message,
                                'timestamp': messageAttente.timestamp
                              })"
                            >
                              <v-icon large color="grey lighten-1">close</v-icon>
                            </v-btn>
                          </v-list-tile-action>

                        </v-list-tile>
                      <v-divider inset></v-divider> 
                    </v-flex>
                  </div>

              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex v-if="dataMessageSelected" xs12 sm9 class="traficInfosVisiteur fill-height">
          <div v-if="loadingHistoChat" class="wz_loadingChat text-xs-center">
            <v-progress-circular :size="70" :width="1" indeterminate class="primary--text"></v-progress-circular>
          </div>
          <wz-view-chat
            v-else
            :datasViewPupitre="dataVisiteurComputed"
            :timestampMessageSelected="dataVisiteurComputed"
            :placesPupitre="1"
            @click.native="focusView({'view': 1, 'visiteurID': messageAttenteSelected.visiteurID})"
            @activeCobrowsing="openCobrowsing(0)"
            @stopCobrowsing="closeCobrowsing(0)"
            @MAJHistoChat="MAJHistoChat"
          ></wz-view-chat>
        </v-flex>
      </v-layout>


      <v-layout v-else row wrap class="layoutTraficVisiteurs bigChat">

      <!-- liste des messages par agent -->
        <v-flex  v-if="
          (typeClassement == 'agent' && !dataVisiteurComputed.visiteurID && $vuetify.breakpoint.xsOnly) || 
          (typeClassement == 'agent' && !$vuetify.breakpoint.xsOnly)
        "
        v-bar
          xs12 
          :class="{
              sm3 : dataMessageSelected,
              listeAgentsOverflow : dataMessageSelected
              }"
          class="traficListVisiteurs fill-height vb"
        >
          <v-card class="cardTraficVisiteurs">
            <v-card-title class="">
              <!-- menu classement -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :loading="loadingMessages"
                    :disabled="loadingMessages"
                    color="primary"
                    class="white--text"
                    v-on="on"
                  >
                    <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('ranking')|cap}}</span>
                    <v-icon 
                      :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                      dark
                    >groups</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in itemsClassement"
                    :key="index"
                    @click="getAllMessagesAttente(listeAgentId, item.type)"
                  >
                    <v-list-tile-title>
                      
                      <v-icon 
                        :left="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                      >{{item.icone}}</v-icon>
                      <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{item.title}}</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>


              <!-- affiche la liste de tous les messages en attente-->
<!--
              <v-btn
                :loading="loadingMessages"
                :disabled="loadingMessages"
                color="primary"
                class="white--text"
                @click="getAllMessagesAttente(listeAgentId)"
              >
                <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('Voir tous les messages')}}</span>
                <v-icon 
                  :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                  dark
                >toc</v-icon>
              </v-btn>
-->
            </v-card-title>

            <v-card-text>
              <!-- affiche les messages en attente de tous les conseillers pour les administrateurs -->
              <v-subheader>{{ $tc('agents', agents.length, { count: agents.length }) }}</v-subheader>
                <v-expansion-panel focusable >
                  <v-expansion-panel-content
                    v-for="(agent,i) in agents"
                    :key="i"
                    
                  >
                    <div slot="header" class="listeAgentsManagement">
                      <wz-avatar
                        :username="agent.name"
                        :src="`${domaine}/public/media/user/small/${agent.id}_avatar.jpg`"
                        size="35px"
                      ></wz-avatar>
                      {{ agent.name }}
                      {{ isItMe(agent.id) ? '(' + $t('me') + ')' : '' }}
                      - <i class="grey--text"> ({{user.colleagues[i].listeMessages.length ? user.colleagues[i].listeMessages.length + ' message(s)' : 'pas de message en attente' }})</i>
                    </div>

                    <v-card class="grey lighten-3">
                      <v-card-title class="">
                        <v-btn
                          :loading="loadingMessages"
                          :disabled="loadingMessages"
                          color="primary"
                          class="white--text"
                          @click="getMessagesAttente([agent.id])"
                        >
                          <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('reload')}}</span>
                          <v-icon 
                            :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                            dark
                          >cached</v-icon>
                        </v-btn>
                      </v-card-title>

                      <v-card-text>
                        <v-list two-line dense class="listeTraficVisiteurs grey lighten-3">
                          <!--<v-subheader>General</v-subheader>-->
                          <div class="wz_wrapChips" v-for="(visitor, i) in user.colleagues[i].listeMessages" :key="i">
                            <v-flex xs12 sm12
                              class="visiteurFiltrer"
                            >
                          
                                <v-list-tile
                                  :class="{ 'light-blue lighten-4': messageAttenteSelected.visiteurID == visitor.visiteurID,  }"
                                  ripple
                                  :key="visitor.status"
                                  @click="openMessageVisiteur(agent.id, visitor)"
                                >
                                
                                  <v-list-tile-avatar>
                                    <wz-avatar
                                      v-if="visitor.network == 'moon' || !visitor.network"
                                      :username="'#' + visitor.visiteurID"
                                      size="38px"
                                      class="pl-1"
                                    ></wz-avatar>
                                    <wz-avatar
                                      v-else-if="visitor.network == 'facebook'"
                                      :src="visitor.profile_pic"
                                      :username="visitor.visiteurName"
                                      size="38px"
                                      class="pl-1"
                                    ></wz-avatar>
                                    <wz-avatar
                                      v-else-if="visitor.network == 'whatsapp'"
                                      :src="visitor.profile_pic"
                                      :username="visitor.visiteurName"
                                      size="38px"
                                      class="pl-1"
                                    ></wz-avatar>
                                    <wz-avatar
                                      v-else-if="!istypingVisiteur && visitor.message && visitor.visiteurID != messageAttenteSelected.visiteurID"
                                      :username="'#' + visitor.visiteurID"
                                      size="38px"
                                      lastMessage
                                    ></wz-avatar>
                                    <wz-avatar
                                      v-else-if="istypingVisiteur"
                                      :isTyping="istypingVisiteur"
                                      :username="'#' + visitor.visiteurID"
                                      size="38px"
                                      chip
                                    ></wz-avatar>
                                  </v-list-tile-avatar>
                                  
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      <div v-if="visitor.network == 'moon' || !visitor.network" class="wz_nameVisiteur">
                                        {{visitor.visiteurID}} <span>({{dateMessageFromNow(visitor.timestamp)}})</span>
                                      </div>
                                      <div v-if="visitor.network == 'email'" class="wz_nameVisiteur">
                                        {{visitor.visiteurID}} <span>({{dateMessageFromNow(visitor.timestamp)}})</span>
                                      </div>
                                      <div v-else-if="visitor.network == 'facebook'" class="wz_nameVisiteur">
                                        {{visitor.visiteurName}} <span>({{dateMessageFromNow(visitor.timestamp)}})</span>
                                      </div>
                                      <div v-else-if="visitor.network == 'whatsapp'" class="wz_nameVisiteur">
                                        {{visitor.visiteurName}} <span>({{dateMessageFromNow(visitor.timestamp)}})</span>
                                      </div>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title v-if="visitor.message.length">
                                        <div
                                          slot="activator"
                                          v-if="visitor.message.length"
                                          class="wz_alertFiltre"
                                        >
                                          <v-icon v-if="visitor.network == 'moon' || !visitor.network" size="20" class="secondary--text text--lighten-1">chat_bubble</v-icon>
                                          <v-icon v-else-if="visitor.network == 'email'" size="20" class="blue-grey--text lighten-2">email</v-icon>
                                          <v-icon v-else-if="visitor.network == 'facebook'" size="20" color="blue accent-4--text" class=" ">mdi-facebook-messenger</v-icon> 
                                          <v-icon v-else-if="visitor.network == 'whatsapp'" size="20" color="green accent-4--text" class=" ">mdi-whatsapp</v-icon>
                                        <div class="d-inline">{{visitor.message[0]}}</div>
                                        </div>
                                      
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>

                                  <v-list-tile-action>
                                    <v-btn flat slot="activator" icon color="accent"
                                      @mouseover.native="overMenu = true"
                                      @mouseleave.native="overMenu = false"
                                      @click="suppMessage({
                                        'messageId': visitor.messageId,
                                        'agentId': visitor.agentId,
                                        'visiteurId': visitor.visiteurID,
                                        'message': visitor.message,
                                        'timestamp': visitor.timestamp
                                      })"
                                    >
                                      <v-icon large color="grey lighten-1">close</v-icon>
                                    </v-btn>
                                  </v-list-tile-action>

                                </v-list-tile>
                              <v-divider inset></v-divider> 
                            </v-flex>
                          </div>
                      </v-list>
                    </v-card-text>
                  </v-card>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-flex>


      <!-- liste des messages par site -->
        <v-flex  v-if="
          (typeClassement == 'site' && !dataVisiteurComputed.visiteurID && $vuetify.breakpoint.xsOnly) || 
          (typeClassement == 'site' && !$vuetify.breakpoint.xsOnly)
        "
        v-bar
          xs12 
          :class="{
              sm3 : dataMessageSelected,
              listeAgentsOverflow : dataMessageSelected
              }"
          class="traficListVisiteurs fill-height vb"
        >
          <v-card class="cardTraficVisiteurs">
            <v-card-title class="">


              <!-- menu classement -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :loading="loadingMessages"
                    :disabled="loadingMessages"
                    color="primary"
                    class="white--text"
                    v-on="on"
                  >
                    <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('ranking')|cap}}</span>
                    <v-icon 
                      :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                      dark
                    >language</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in itemsClassement"
                    :key="index"
                    @click="getAllMessagesAttente(listeAgentId, item.type)"
                  >
                    <v-list-tile-title>
                      
                      <v-icon 
                        :left="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                      >{{item.icone}}</v-icon>
                      <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{item.title}}</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-title>

            <v-card-text>
              <!-- affiche les messages en attente de tous les conseillers pour les administrateurs -->
              <v-subheader>{{ $tc('sites', listeSite.length, { count: listeSite.length }) }}</v-subheader>
              <v-expansion-panel focusable >
                <v-expansion-panel-content
                  v-for="(site,i) in listeSite"
                  :key="i"
                  
                >
                  <div slot="header" class="listeAgentsManagement">
                    {{ site.url }} 
                    - <i class="grey--text"> ({{site.numMessage ? site.numMessage + ' message(s)' : 'pas de message en attente' }})</i>
                  </div>
                    <v-card class="grey lighten-3">
                      <v-card-title class="">
                        <!--
                        <v-btn
                          :loading="loadingMessages"
                          :disabled="loadingMessages"
                          color="primary"
                          class="white--text"
                          @click="getMessagesAttente([agent.id])"
                        >
                          <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$tc('reload')}}</span>
                          <v-icon 
                            :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                            dark
                          >cached</v-icon>
                        </v-btn>
                        -->
                      </v-card-title>

                      <v-card-text>
                        <v-list two-line dense class="listeTraficVisiteurs grey lighten-3">
                          <!--<v-subheader>General</v-subheader>-->
                          <div class="wz_wrapChips" v-for="(message, i) in listeAllMessagesAttente" :key="i">
                            <v-flex xs12 sm12
                              class="visiteurFiltrer"
                            >
                              <div v-if="message.siteID == site.id || message.network == site.id">

                                <v-list-tile
                                  :class="{ 'light-blue lighten-4': messageAttenteSelected.visiteurID == message.visiteurID,  }"
                                  ripple
                                  :key="message.status"
                                  @click="openMessageVisiteur(message.agentId, message)"
                                >

                                  <v-list-tile-avatar>
                                    <wz-avatar-double
                                      v-if="message.network == 'moon' || !message.network"
                                      :avatars="[{network: 'moon', id: message.visiteurID, username: message.visiteurName, isTyping: false, chip: false}, {id: message.agentId, username: message.agentName}]"
                                    ></wz-avatar-double>
                                    <wz-avatar-double
                                      v-else-if="message.network == 'facebook'"
                                      :avatars="[{network: 'facebook', src: message.profile_pic, id: message.visiteurID, username: message.visiteurName, isTyping: false, chip: false}, {id: message.agentId, username: message.agentName}]"
                                    ></wz-avatar-double>
                                    <wz-avatar-double
                                      v-else-if="message.network == 'whatsapp'"
                                      :avatars="[{network: 'whatsapp', src: message.profile_pic, id: message.visiteurID, username: message.visiteurName, isTyping: false, chip: false}, {id: message.agentId, username: message.agentName}]"
                                    ></wz-avatar-double>
                                  </v-list-tile-avatar>
                                  
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      <div v-if="message.network == 'moon' || !message.network" class="wz_nameVisiteur">
                                        {{message.visiteurID}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                                      </div>
                                      <div v-if="message.network == 'email'" class="wz_nameVisiteur">
                                        {{message.visiteurID}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                                      </div>
                                      <div v-else-if="message.network == 'facebook'" class="wz_nameVisiteur">
                                        {{message.visiteurName}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                                      </div>
                                      <div v-else-if="message.network == 'whatsapp'" class="wz_nameVisiteur">
                                        {{message.visiteurName}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                                      </div>
                                    </v-list-tile-title>
                                    
                                    <v-list-tile-sub-title v-if="message.message.length">
                                        <div
                                          slot="activator"
                                          v-if="message.message.length"
                                          class="wz_alertFiltre"
                                        >
                                          <v-icon v-if="message.network == 'moon' || !message.network" size="20" class="secondary--text text--lighten-1">chat_bubble</v-icon>
                                          <v-icon v-else-if="message.network == 'email'" size="20" class="blue-grey--text lighten-2">email</v-icon>
                                          <v-icon v-else-if="message.network == 'facebook'" size="20" color="blue accent-4--text" class=" ">mdi-facebook-messenger</v-icon>
                                          <v-icon v-else-if="message.network == 'whatsapp'" size="20" color="green accent-4--text" class=" ">mdi-whatsapp</v-icon> 
                                        <div class="d-inline">{{message.message[0]}}</div>
                                        </div>
                                      
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>

                                  <v-list-tile-action>
                                    <v-btn flat slot="activator" icon color="accent"
                                      @mouseover.native="overMenu = true"
                                      @mouseleave.native="overMenu = false"
                                      @click="suppMessage({
                                        'messageId': message.messageId,
                                        'agentId': message.agentId,
                                        'visiteurId': message.visiteurID,
                                        'message': message.message,
                                        'timestamp': message.timestamp
                                      })"
                                    >
                                      <v-icon large color="grey lighten-1">close</v-icon>
                                    </v-btn>
                                  </v-list-tile-action>

                                </v-list-tile>
                              <v-divider inset></v-divider> 
                            </div>





                            </v-flex>
                          </div>
                        </v-list>
                      </v-card-text>
                    </v-card>

 




                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-flex>


      <!-- liste de tous les message -->
        <v-flex  v-else-if="
          ((typeClassement == 'old' || typeClassement == 'new') && !dataVisiteurComputed.visiteurID && $vuetify.breakpoint.xsOnly) || 
          ((typeClassement == 'old' || typeClassement == 'new') && !$vuetify.breakpoint.xsOnly)
        "
          xs12
          v-bar
          :class="{
              sm3 : dataMessageSelected,
              listeAgentsOverflow : dataMessageSelected
              }"
          class="traficListVisiteurs fill-height vb"
        >
          <v-card>
              <v-card-title class="">


                <!-- menu classement -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :loading="loadingMessages"
                      :disabled="loadingMessages"
                      color="primary"
                      class="white--text"
                      v-on="on"
                    >
                      <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('ranking')}}</span>
                      <v-icon 
                        v-if="typeClassement == 'new'"
                        :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                        dark
                      >flip_to_front</v-icon>
                      <v-icon 
                        v-else-if="typeClassement == 'old'"
                        :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                        dark
                      >flip_to_back</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in itemsClassement"
                      :key="index"
                      @click="getAllMessagesAttente(listeAgentId, item.type)"
                    >
                      <v-list-tile-title>
                        
                        <v-icon 
                          :left="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                        >{{item.icone}}</v-icon>
                        <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{item.title}}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>


                <!-- affiche la liste par agent-->
<!--
                <v-btn
                  v-if="(typeClassement == 'old' || typeClassement == 'new')"
                  :loading="loadingMessages"
                  :disabled="loadingMessages"
                  color="primary"
                  class="white--text"
                  @click="getMessagesAgents()"
                >
                  <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('Voir les messages par agent')}}</span>
                  <v-icon 
                    :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                    dark
                  >supervisor_account</v-icon>
                </v-btn>
-->
                <v-btn
                  :loading="loadingMessages"
                  :disabled="loadingMessages"
                  color="primary"
                  class="white--text"
                  @click="getMessagesAttente(listeAgentId)"
                >
                  <span v-if="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly">{{$t('reload')}}</span>
                  <v-icon 
                    :right="!dataMessageSelected  && !$vuetify.breakpoint.xsOnly"
                    dark
                  >cached</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text>
                <i class="grey--text"> {{listeAllMessagesAttente.length ? 'Il y a actuellement ' + listeAllMessagesAttente.length + ' message(s) en attente d\'une réponse' : 'Pas de message en attente' }}</i>
                <v-list two-line dense class="listeTraficVisiteurs">
                  <!--<v-subheader>General</v-subheader>-->
                  <div class="wz_wrapChips" v-for="(message, i) in listeAllMessagesAttente" :key="i">
                    <v-flex xs12 sm12
                      class="visiteurFiltrer"
                    >
                        <v-list-tile
                          :class="{ 'light-blue lighten-4': messageAttenteSelected.visiteurID == message.visiteurID,  }"
                          ripple
                          :key="message.status"
                          @click="openMessageVisiteur(message.agentId, message)"
                        >
                          <v-list-tile-avatar>
                            <wz-avatar-double
                              v-if="message.network == 'moon' || !message.network"
                              :avatars="[{network: 'moon', id: message.visiteurID, username: message.visiteurName, isTyping: false, chip: false}, {id: message.agentId, username: message.agentName}]"
                            ></wz-avatar-double>
                            <wz-avatar-double
                              v-else-if="message.network == 'facebook'"
                              :avatars="[{network: 'facebook', src: message.profile_pic, id: message.visiteurID, username: message.visiteurName, isTyping: false, chip: false}, {id: message.agentId, username: message.agentName}]"
                            ></wz-avatar-double>
                            <wz-avatar-double
                              v-else-if="message.network == 'whatsapp'"
                              :avatars="[{network: 'whatsapp', src: message.profile_pic, id: message.visiteurID, username: message.visiteurName, isTyping: false, chip: false}, {id: message.agentId, username: message.agentName}]"
                            ></wz-avatar-double>
<!--
                            <wz-avatar
                              v-if="!dejaEnChat && message.network == 'moon' || !dejaEnChat && !message.network"
                              :username="'#' + message.visiteurID"
                              size="38px"
                              class="pl-1"
                            ></wz-avatar>
                            <wz-avatar
                              v-else-if="!dejaEnChat && message.network == 'facebook'"
                              :src="message.profile_pic"
                              :username="message.visiteurName"
                              size="38px"
                              class="pl-1"
                            ></wz-avatar>
                            <wz-avatar
                              v-else-if="!dejaEnChat && !istypingVisiteur && message.message && message.visiteurID != messageAttenteSelected.visiteurID"
                              :username="'#' + message.visiteurID"
                              size="38px"
                              lastMessage
                            ></wz-avatar>
                            <wz-avatar
                              v-else-if="!dejaEnChat && istypingVisiteur"
                              :isTyping="istypingVisiteur"
                              :username="'#' + message.visiteurID"
                              size="38px"
                              chip
                            ></wz-avatar>
 --> 

                          </v-list-tile-avatar>
                          
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <div v-if="message.network == 'moon' || !message.network" class="wz_nameVisiteur">
                                {{message.visiteurID}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                              </div>
                              <div v-if="message.network == 'email'" class="wz_nameVisiteur">
                                {{message.visiteurID}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                              </div>
                              <div v-else-if="message.network == 'facebook'" class="wz_nameVisiteur">
                                {{message.visiteurName}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                              </div>
                              <div v-else-if="message.network == 'whatsapp'" class="wz_nameVisiteur">
                                {{message.visiteurName}} <span>({{dateMessageFromNow(message.timestamp)}})</span>
                              </div>
                            </v-list-tile-title>
                            
                            <v-list-tile-sub-title v-if="message.message.length">
                                <div
                                  slot="activator"
                                  v-if="message.message.length"
                                  class="wz_alertFiltre"
                                >
                                  <v-icon v-if="message.network == 'moon' || !message.network" size="20" class="secondary--text text--lighten-1">chat_bubble</v-icon>
                                  <v-icon v-else-if="message.network == 'email'" size="20" class="blue-grey--text lighten-2">email</v-icon>
                                  <v-icon v-else-if="message.network == 'facebook'" size="20" color="blue accent-4--text" class=" ">mdi-facebook-messenger</v-icon> 
                                  <v-icon v-else-if="message.network == 'whatsapp'" size="20" color="green accent-4--text" class=" ">mdi-whatsapp</v-icon>
                                <div class="d-inline">{{message.message[0]}}</div>
                                </div>
                              
                            </v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-btn flat slot="activator" icon color="accent"
                              @mouseover.native="overMenu = true"
                              @mouseleave.native="overMenu = false"
                              @click="suppMessage({
                                'messageId': message.messageId,
                                'agentId': message.agentId,
                                'visiteurId': message.visiteurID,
                                'message': message.message,
                                'timestamp': message.timestamp
                              })"
                            >
                              <v-icon large color="grey lighten-1">close</v-icon>
                            </v-btn>
                          </v-list-tile-action>

                        </v-list-tile>
                      <v-divider inset></v-divider> 
                    </v-flex>
                  </div>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex v-if="dataMessageSelected" xs12 sm9 class="traficInfosVisiteur fill-height">
          <div v-if="loadingHistoChat" class="wz_loadingChat text-xs-center">
            <v-progress-circular :size="70" :width="1" indeterminate class="primary--text"></v-progress-circular>
          </div>
          <wz-view-chat
            v-else
            :datasViewPupitre="dataVisiteurComputed"
            :placesPupitre="1"
            @click.native="focusView({'view': 1, 'visiteurID': messageAttenteSelected.visiteurID})"
            @activeCobrowsing="openCobrowsing(0)"
            @stopCobrowsing="closeCobrowsing(0)"
            @MAJHistoChat="MAJHistoChat"
          ></wz-view-chat>
        </v-flex>



      </v-layout>
    </div>


    <!-- dialogBox de confirmation de suppression-->
    <v-dialog v-model="dialogSupMessage" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('supMessageAttenteTitre') | cap }}</v-card-title>
        <v-card-text>
          {{ $t('supMessageAttenteContent') | cap }}
        </v-card-text>
        <!-- $t('contentDialogSessionClose') -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="dialogSupMessage=false">{{$t('no')}}</v-btn>
          <v-btn
            class="white--text darken-1"
            :loading="loadingSupp"
            :disabled="loadingSupp"
            color="accent"
            @click="confirmSuppMessage()"
          >
          {{$t('yes')}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialogBox open chat-->
    <v-dialog v-model="dialogOpenChatPush" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('openChat') | cap }}</v-card-title>
        <v-card-text>
          {{ $t('dialogRepVisiteur') | cap }} ({{directChat}})
        </v-card-text>
        <!-- $t('contentDialogSessionClose') -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="dialogOpenChatPush=false">{{$t('no')}}</v-btn>
          <v-btn
            class="white--text darken-1"
            :loading="loadingSupp"
            :disabled="loadingSupp"
            color="accent"
            @click="checkIdVisiteurURL(directChat)"
          >
          {{$t('yes')}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<style>
.targetFirst_loading {
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  position: fixed;
}
.layoutTraficVisiteurs.smallChat .traficInfosVisiteur {
    -ms-flex-preferred-size: 75% !important;
    flex-basis: 75% !important;
    max-width: 75% !important;
}

.visiteurAttente .v-avatar {
    float: left;
}
.layoutTraficVisiteurs {
  height: calc(100vh - 104px) !important;
}
/*
.cardTraficVisiteurs {
  height:100% !important;
}
*/
.wz_contentListesVisiteurs {
  height: calc(100vh - 176px);
  overflow: auto;
  position: relative;
}
.wz_loadingChat {
  top: calc(50% - 35px);
  position: relative;
}
</style>

<script>
import _ from 'lodash'
import { DOMAINE } from '../../constants'
import { mapState, mapGetters, mapMutations } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js'
import monitor from '../../mixins/monitor'
import moment from 'moment'
export default {
  mixins: [monitor],

  data () {
    return {
      domaine: DOMAINE,
      dialogSupMessage: false,
      dialogOpenChatPush: false,
      loadingSupp: false,
      loadingMessages: false,
      chatStatus: false,
      listeComputedMessages: [],
      loadingHistoChat: false,
      visiteurData: {},
      dejaEnChat: 0,
      istypingVisiteur: 0,
      messageIdSelected: 0,
      messageAgentIdSelected: 0,
      messageVisiteurIdSelected: 0,
      messageSelected: '',
      messageTimestamp: 0,
      resAjx: null,
      viewAllMessageAttente: true,
      typeClassement: 'old',
      numMessageSite: [],
      checkConnexion: null,
      /**
       * Liste des agents affichés
       * @type {Array}
       */
      agents: [],
      itemsClassement: [
        { title: this.$t('byAgent'), type: 'agent', icone: 'groups' },
        { title: this.$t('byWebSite'), type: 'site', icone: 'language' },
        { title: this.$t('mostRecent'), type: 'new', icone: 'flip_to_front' },
        { title: this.$t('oldest'), type: 'old', icone: 'flip_to_back' }
      ],
      itemsClassementPeon: [
        { title: this.$t('mostRecent'), type: 'new', icone: 'flip_to_front' },
        { title: this.$t('oldest'), type: 'old', icone: 'flip_to_back' }
      ]
    }
  },

  created () {
    if (this.hideTabVisitors) {
      this.$router.push({ path: '/trafic/attente' })
    }
    // clear les data du visiteur deja ouvert pour ne pas ouvrire par defaut une fenetre chat avec des erreurs js
    this.$store.commit('_StoreWatcheeBox/CLEAR_MESSAGE_ATTENTE')
    // parse le tableau pour trouve le visiteur qui vient d'un reseau social
    if (this.$cookie.get('wz-clsMessaging')) {
      this.typeClassement = this.$cookie.get('wz-clsMessaging')
    }
    if (!this.directChat) {
      // mais si l'agent arrive directement sur cette page attente (via window.navigate dans le serviceworker)
      if (this.$route.query.directChat) {
        // this.directChat = this.$route.query.directChat
        sessionStorage.setItem('tf-directChat', this.$route.query.directChat)
        this.getMessagesAttente(this.$store.state._User.id)
      } else {
        sessionStorage.removeItem('tf-directChat')
      }
    } else {
      console.log('il y a un chat en session')
      this.getMessagesAttente(this.$store.state._User.id)
      // this.$router.push({ path: '/trafic/attente/' + sessionStorage.getItem('tf-directChat') })
    }
  },
  mounted () {
    // console.log('this.$store.state._User', this.$store.state._User)
    // if (this.$store.state._User.entId === '5') {
      // this.rights.push({ text: 'Admin Watcheezy', value: 999 })
    // }
    // recuperation de la liste des agents
    this.loading = true
    this.axios.get('get/agents.php')
    .then(response => {
      this.resAjx = response.data
      this.initListAgent()
    })
    .catch()
    .then(_ => {
      this.loading = false
    })
    // vide la liste des message en attente
    this.addArrayListeMessageAttente()
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', [
      'SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE'
    ]),
    ...mapMutations('_User', [
      'SET_COLLEAGUE_MESSAGE_ATTENTE',
      'SET_DEL_MESSAGE_ATTENTE',
      'SET_AVATAR_MESSAGE_ATTENTE',
      'SET_COLLEAGUE_ADD_LISTEMESSAGES'
    ]),
    // initialise la liste des agents
    initListAgent () {
      // console.log('this.resAjx', this.resAjx)
      for (var id in this.resAjx) {
        let parturlon = this.resAjx[id][0].USR_SITE_LIST
        let parturloff = this.resAjx[id][0].USR_NONSITE_LIST
        if (this.resAjx[id][0].USR_SITE_LIST.indexOf('|') !== -1) {
          let arrayOfStrings = this.resAjx[id][0].USR_SITE_LIST.split('|')
          parturlon = arrayOfStrings[0]
          parturloff = arrayOfStrings[1]
          if (!parturloff || parturloff === '') {
            parturloff = this.resAjx[id][0].USR_NONSITE_LIST
          }
        }
        this.agents.push({ id: this.resAjx[id][0].USR_ID,
          name: _.trim(this.resAjx[id][0].USR_FIRST_NAME + ' ' + this.resAjx[id][0].USR_LAST_NAME),
          firstname: this.resAjx[id][0].USR_FIRST_NAME,
          lastname: this.resAjx[id][0].USR_LAST_NAME,
          job: this.resAjx[id][0].USR_JOB,
          activity: this.resAjx[id][0].USR_ACTIVITY,
          email: this.resAjx[id][0].USR_MAIL_CONTACT,
          chatmax: this.resAjx[id][0].USR_NB_CHAT_MAX,
          priority: this.resAjx[id][0].USR_PRIORITY,
          keywords: this.resAjx[id][0].USR_KEYWORDS,
          parturl: parturlon,
          partnourl: parturloff,
          rights: _.toInteger(this.resAjx[id][0].USR_RIGHTS),
          notifonoff: this.resAjx[id][0].USR_CHAT_NOTIF_ONOFF === '1',
          closechatonoff: this.resAjx[id][0].USR_CLOSECHAT_ONOFF === '1',
          closechataction: this.resAjx[id][0].USR_CLOSECHAT_ACTION,
          closechatdetails: this.resAjx[id][0].USR_CLOSECHAT_DETAILS,
          filterlist: this.resAjx[id][0].USR_FIL_LIST.length,
          canBeUnavailable: this.resAjx[id][0].USR_CAN_UNAVAILABLE === '1',
          timeTransfert: this.resAjx[id][0].USR_TIME_TRANSFERT,
          tempsTravail: this.resAjx[id][0].USR_TIME_DAY,
          jourHebdoTravail: this.resAjx[id][0].USR_DAY_HEBDO,
          isbot: this.resAjx[id][0].USR_IS_BOT !== '',
          botid: this.resAjx[id][0].USR_IS_BOT,
          notifBo: this.resAjx[id][0].USR_BO_NOTIF === '1'
        })
      }
      // console.log('this.agents', this.agents)
      // chargement des messages en attente
      // this.loadingMessagesAttente()
    },
    onExpansionPanelClick (data) {
      // console.log('click', data)
    },
    isItMe (id) {
      return Number.parseInt(this.$store.state._User.id) === Number.parseInt(id)
    },
    // ----------------------------------------------------------------------------
    // regarde si id visiteur dans l'url pour ouvrir directement le chat
    // ----------------------------------------------------------------------------
    checkIdVisiteurURL (id) {
      console.log('visiteur id', id)
      this.loadingHistoChat = true
      if (id) {
        // this.getMessagesAttente(id, function (message) {
        //   if (message.response === 'ok') {
        //     console.log('messages chargés')
        //     console.log('on peut ouvrire le chat')
        //   } else {
        //     console.log('pas de message')
        //   }
        // })

        let myId = this.$store.state._User.id
        let listColegues = this.$store.state._User.colleagues
        let idVisiteur = id
        let index = _.findIndex(listColegues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(myId) })
        console.log('index agent', index)
        if (index !== -1) {
          let indexMessage = _.findIndex(listColegues[index].listeMessages, function (o) { return o.visiteurID === idVisiteur })
          console.log('indexMessage', indexMessage)
          if (indexMessage !== -1) {
            // il y a un message, on peut l'ouvrir
            this.openMessageVisiteur(myId, listColegues[index].listeMessages[indexMessage])
            console.log('indexMessage', listColegues[index].listeMessages[indexMessage])
            this.loadingHistoChat = false
          } else {
            this.loadingHistoChat = false
          }
        }
      } else {
        console.log('pas de id visiteur')
        this.loadingHistoChat = false
      }
      this.dialogOpenChatPush = false
    },

    // ----------------------------------------------------------------------------
    // supprime un message
    // ----------------------------------------------------------------------------
    suppMessage (data) {
      console.log('data', data)
      this.messageIdSelected = Number.parseInt(data.messageId) ? Number.parseInt(data.messageId) : 0
      this.messageAgentIdSelected = data.agentId
      this.messageVisiteurIdSelected = data.visiteurId
      this.messageSelected = data.message[0]
      this.messageTimestamp = data.timestamp
      // affiche la fenetre de confirmation
      this.dialogSupMessage = true
    },

    // ----------------------------------------------------------------------------
    // chargement des messages en attente
    // ----------------------------------------------------------------------------
    // loadingMessagesAttente () {
      // console.log('this.agents.length', this.agents.length)
      // console.log('this.listeAgentId', this.listeAgentId)
      // // Uniquement si la liste d'agent est vide on charge les agent
      // if (this.agents.length) {
      //   console.log('this.$store.state._User.rights', this.$store.state._User.rights)
      //   // chargement de ses message en attante uniquement pour les imples agent
      //   if (!this.$store.state._User.rights && this.$store.state._User.rights !== 1) {
      //     // uniquement mes messages
      //     console.log('uniquement mes messages')
      //     this.getMessagesAttente(this.$store.state._User.id)
      //   } else {
      //     // charge tous les message en attente des agents
      //     console.log('tous les messages')
      //     this.getMessagesAttente(this.listeAgentId)
      //   }
      // }
    // },

    // ----------------------------------------------------------------------------
    // Affiche la liste des messages par agent
    // ----------------------------------------------------------------------------
    getMessagesAgents (data, classement) {
      this.viewAllMessageAttente = false
      this.typeClassement = classement
      console.log('getMessagesAgents')
      this.$cookie.set('wz-clsMessaging', classement, { expires: '1Y' })
      // efface les messages en attent de cet agent uniquement avant de refair le tableau
    },

    // ----------------------------------------------------------------------------
    // Affiche la liste de tous les messages
    // ----------------------------------------------------------------------------
    getAllMessagesAttente (data, classement) {
      this.viewAllMessageAttente = true
      this.typeClassement = classement
      console.log('getAllMessagesAttente', classement)
      this.$cookie.set('wz-clsMessaging', classement, { expires: '1Y' })
      // efface tous les messages en attente avant de remplir les tableaux
      // this.getMessagesAttente(data)
    },

    addArrayListeMessageAttente () {
      this.SET_COLLEAGUE_ADD_LISTEMESSAGES()
    },

    // ----------------------------------------------------------------------------
    // Il faut mettre à jour l'historique de chat pour les message en attente uniquement
    // ----------------------------------------------------------------------------
    MAJHistoChat (data) {
      console.log('MAJHistoChat', data)
      this.MonitorMajHistoChat(data)
    },

    // ------------------------------------------------------------------------------
    // Chargement des messages en attente
    // ------------------------------------------------------------------------------
    getMessagesAttente (userID, callback) {
      console.log('get messages attente', userID)
      // this.loading = true
      this.loadingMessages = true
      this.axios
      .get(
        'get/chats_abscence.php?agentId=' +
          userID
      )
      .then(response => {
        console.log('response', response)
        if (response.data.length) {
          // si je suis un simple conseiller (j'ai acces uniquement à mes messages en attente)
          // je les stock uniquement au niveau du store user
          /*
          if (this.userRights === 1) {
            this.SET_MESSAGE_ATTENTE(response.data)
          // sinon il faut mettre à jour le tableau des collegues
          } else {
          */
          this.SET_COLLEAGUE_MESSAGE_ATTENTE({
            'liste': response.data,
            'agentId': userID
          })

          // this.checkConnexion = setInterval(this.checkIsConnected, 1000)
          if (this.isMobile) {
            this.dialogOpenChatPush = true
            this.loadingMessages = false
          } else {
            console.log('go checkIdVisiteurURL')
            this.checkIdVisiteurURL(this.directChat)
            this.loadingMessages = false
          }
          callback({'response': 'ok'})
        } else {
          this.loadingMessages = false
          console.log('Aucun message en attente')
          callback({'response': 'ko'})
        }
        // console.log('this.listeMessages', this.listeMessages)
        // this.loading = false
        // console.log('length', this.listeMessages.length)
        this.loadingMessages = false
      })
      .catch(_ => {
        // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
      })
      .then(_ => {
      })
    },

    // ------------------------------------------------------------------------------
    // Ajout de l'avatar si message en attente reseaux sociaux
    // ------------------------------------------------------------------------------
    getAvatarVisiteur (data) {
      console.log('getAvatarVisiteur', data)
      this.axios
      .get(
        'get/chats_abscence_avatar.php?visitorId=' +
          data.visiteurData.visiteurID
      )
      .then(response => {
        // console.log('response', response.data)
        if (response.data) {
          // return response.data
          data.visiteurData.profile_pic = response.data
          // let messagesList = _.cloneDeep(this.$store.state._User.user.listeMessages)
          // messagesList.splice(data.key, 1, data.visiteurData) // change l'etat du over sur le drop
          this.SET_AVATAR_MESSAGE_ATTENTE(data)
          // this.loadingMessages = false
          // console.log('this.listeMessages', this.user.listeMessages)
        }
      })
      .catch(_ => {
        // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
      })
      .then(_ => {
      })
    },
    // ----------------------------------------------------------------------------
    // confirmation de la suppression du message
    // ----------------------------------------------------------------------------
    confirmSuppMessage () {
      console.log('confirmSuppMessage', this.messageIdSelected)
      let suppId = this.messageIdSelected
      let agentId = this.messageAgentIdSelected
      let visiteurId = this.messageVisiteurIdSelected
      let message = this.messageSelected
      let timestamp = this.messageTimestamp
      let dataToPost = new window.FormData()
      dataToPost.append('messageId', suppId)
      dataToPost.append('agentId', agentId)
      dataToPost.append('visiteurId', visiteurId)
      dataToPost.append('message', message)
      dataToPost.append('timestamp', timestamp)
      // indique en base que le message est lu
      this.axios
      .post('post/messageAttenteLu.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      // console.log('suppId 1', suppId)
      // les changements été pris en compte
      // il faut retirer le message de la liste
      .then(response => {
        // console.log('suppId 2', suppId)
        // si je suis un simple conseiller

        // console.log('je suis un super conseiller')
        // affacer le message
        // id de l'agent qui à recus ce message
        let idAgentMessage = this.messageAgentIdSelected
        console.log('idAgentMessage', idAgentMessage)
        // recupère l'index du message supprimé
        let index = _.findIndex(this.$store.state._User.colleagues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(idAgentMessage) })
        console.log('index agent', index)
        if (index !== -1) {
          // console.log('il y a une liste de message :', idAgentMessage)
          if (this.$store.state._User.colleagues[index].listeMessages.length) {
            // clone le tableau avant de travailler dessus
            let messagesList = _.cloneDeep(this.$store.state._User.colleagues[index].listeMessages)
            console.log('messagesList', messagesList)
            // recupère l'index du message supprimé avec sont id (par defaut)
            let indexMessage
            // si il y a un retour avec l'id du message, c'est que je ne l'ai pas dans le le message dans la liste
            // il faut utiliser le timestamp pour l'effacer des liste attente
            if (response.data.id) {
              // recupère l'index du message supprimé avec le timestamp
              indexMessage = _.findIndex(messagesList, function (o) { return o.timestamp === timestamp })
            } else {
              console.log('pas de id message')
              indexMessage = _.findIndex(messagesList, function (o) { return o.messageId === suppId })
            }
            console.log('indexMessage2', indexMessage)
            if (indexMessage !== -1) {
              messagesList.splice(indexMessage, 1)
              // mise à jour de user.listeMessages
              this.SET_DEL_MESSAGE_ATTENTE({
                'liste': messagesList,
                'agentId': idAgentMessage
              })
              /*
              // Si c'est mon chat je doit aussi mettre à jour ce tableau
              if (this.isItMe(idAgentMessage)) {
                // mise à jour de user.listeMessages
                this.SET_MESSAGE_ATTENTE(messagesList)
              }
              */
            }
          } else {
            console.log('pas de liste pour :', idAgentMessage)
          }
        }
      })
      .catch(_ => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('modifFailure'),
          context: 'error'
        })
      })
      .then(_ => {
        // stop le loading du bouton
        this.loadingSupp = false
        // ferme la fenetre dialog
        this.dialogSupMessage = false
        this.messageIdSelected = 0
        this.messageAgentIdSelected = 0
        this.messageVisiteurIdSelected = 0
        this.messageSelected = ''
        this.messageTimestamp = 0
      })
    },

    // ----------------------------------------------------------------------------
    // Si ce visiteur est deja en chat
    // Check avec quel agent ce visiteur est en chat
    // si c'est moi j'ouvre le chat si c'est un autre agent j'ouvre une dialogBox
    // ----------------------------------------------------------------------------
    openMessageVisiteur (agentId, data) {
      console.log('openMessageVisiteur', agentId)
      console.log('openMessageVisiteur data', data)
      // console.log('entId', this.user.entId)
      if (this.overMenu) return
      if (this.messageAttenteSelected.visiteurID === data.visiteurID) {
        // return // pour eviter d'ouvrir un chat deja ouvert
      } else {
        this.loadingHistoChat = true
        // --------------- DEMANDE HISTORIQUE DE CHAT
        _watcheebox
          .firstLoadHistoChat({
            chatSession: data.visiteurID,
            entrepriseId: this.user.entId
          })
          .then(histoChat => {
            console.log('histoChat', histoChat)
            let visClone = _.cloneDeep(data)
            visClone.histoChat = histoChat
            // enregistre les donnée du visiteur dans le store
            console.log('set visiteur openchat', visClone)
            this.showChat(visClone)
            this.visiteurData = visClone // mise à jour des data visiteur selectionné
            // mise à jour du store pour les donnée visiteur offline
            let visOfflineClone = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened)
            // let visOfflineClone = []
            visOfflineClone.agentIdSelected = agentId
            visOfflineClone.histoChat = histoChat
            visOfflineClone.visiteurID = visClone.visiteurID
            console.log('visOfflineClone', visOfflineClone)
            this.SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE(visOfflineClone)
          })
          .catch(e => {
            console.error(e)
          })
        // -------------------------------------------
      }
    },

    // ----------------------------------------------------------------------------
    // chargement avant affichage du chat et des infos
    // ----------------------------------------------------------------------------
    loadingChat (visiteurInfos) {
      // this.visSelected = visiteurInfos.visiteurID // indique quel visiteur est selectionné
      this.loadingHistoChat = true
    },

    // ----------------------------------------------------------------------------
    // affiche le chat
    // ----------------------------------------------------------------------------
    showChat (visiteurInfos) {
      // console.log('showChat', visiteurInfos)
      this.loadingHistoChat = false
      this.chatStatus = true // iframe visible
      // Connection à la room visiteur
      _watcheebox.clientConnectRoom({'roomName': 'chat_' + visiteurInfos.visiteurID})
      // Enregistre dans le store l'id du visiteur
      this.$store.commit('_StoreWatcheeBox/VISITEUR_ADD_CHAT', {sessionID: visiteurInfos.visiteurID, dataVisiteur: visiteurInfos})
      // this.startCheckInfos() // start le monitor
      // indique que la fiche visiteur est ouverte
      this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', visiteurInfos)
    },

    dateMessageFromNow (date) {
      // console.log('date', date)
      // var dateString = moment.unix(date)
      // console.log('date', dateString)
      // return dateString
      return moment.unix(date).fromNow()
    }
  },

  beforeDestroy () {
    // effacer le directChat dans session quant il y a changement de page
    sessionStorage.removeItem('tf-directChat')
  },

  watch: {
  },

  computed: {
    ...mapGetters('_User', ['user', 'account', 'id']),
    ...mapState('_User', ['hideTabVisitors', 'colleagues', 'id']),
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'mySocketID',
      'messageAttenteSelected',
      'allDataVisiteurOpened',
      'status',
      'isConnected',
      'socketStatus'
    ]),
    // mon id
    myId () {
      return this.id
    },
    // suis je connecté au socket ?.
    connexionSocket () {
      if (this.$socket !== undefined) {
        console.log('mySocketID', this.$socket)
        return true
      } else {
        return false
      }
    },
    userRights () {
      console.log('this.account.rights', this.account.rights)
      return this.account.rights
    },
    // affiche si l'object message selcted est remplis ou non
    dataMessageSelected () {
      return Object.keys(this.messageAttenteSelected).length
    },
    // Affiche ma liste de message en attentes
    maListeMessagesAttente () {
      let listeAllMessages = []
      let agentId = _.cloneDeep(this.$store.state._User.id)
      let colleaguesListe = _.cloneDeep(this.$store.state._User.colleagues)
      let index = _.findIndex(colleaguesListe, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(agentId) })
      if (index !== -1) {
        listeAllMessages = _.cloneDeep(this.colleagues[index].listeMessages)
        if (this.typeClassement === 'new') {
          listeAllMessages.sort(function (a, b) {
            return b.timestamp - a.timestamp
          })
        } else {
          listeAllMessages.sort(function (a, b) {
            return a.timestamp - b.timestamp
          })
        }
        // return le tableau trié
        // console.log('maListeMessagesAttente', listeAllMessages)
        return listeAllMessages
      }
    },

    // Affiche la liste de tous les messages en attente
    listeAllMessagesAttente () {
      // console.log('listeAllMessagesAttente', this.typeClassement)
      let listeAllMessages = []
      _.forEach(
        this.$store.state._User.colleagues,
        (agent, key) => {
          _.forEach(
            agent.listeMessages,
            (message, key) => {
              message.agentName = agent.USR_FIRST_NAME + ' ' + agent.USR_LAST_NAME
              listeAllMessages.push(message)
            }
          )
        }
      )
      // console.log('listeAllMessages', listeAllMessages)
      // trie le tableau par timestamp
      // classement les plus vieux en premier
      if (this.typeClassement === 'new') {
        listeAllMessages.sort(function (a, b) {
          return b.timestamp - a.timestamp
        })
      } else {
        listeAllMessages.sort(function (a, b) {
          return a.timestamp - b.timestamp
        })
      }
      // console.log('listeAllMessagesAttente', listeAllMessages)
      // if (this.directChat) {
      //   console.log('il y a un chat en session')
      //   // this.$router.push({ path: '/trafic/attente/' + sessionStorage.getItem('tf-directChat') })
      //   this.checkConnexion = setInterval(this.checkIsConnected(this.directChat), 1000)
      // } else {
      //   console.log('pas de chat en session')
      // }
      // return le tableau trié
      return listeAllMessages
    },

    // il faut checker si tous est chargé avant d'ouvrir automatiquemet un chat
    checkDirectChat () {
      // console.log('this.$socket', this.$socket)
      if (this.isConnected) {
        // console.log('checkDirectChat ok')
        return true
      } else {
        // console.log('checkDirectChat pas encore ok')
        return false
      }
    },

    // Liste des id agents
    listeAgentId () {
      let arrayIdAgent = []
      _.forEach(
        this.$store.state._User.colleagues,
        (agent, key) => {
          arrayIdAgent.push(agent.USR_ID)
        }
      )
      return arrayIdAgent
    },

  // Liste des sites internet et reseaux sociaux + nombre de message en attente par site
    listeSite () {
      // numMessageSite
      let arraySite = []
      // pour chaque site
      _.forEach(
        this.$store.state._Sites.sites,
        (site, key) => {
          let numMessage = 0
          // pour chaque agent
          _.forEach(
            this.$store.state._User.colleagues,
            (agent, key) => {
              // pour chaque message
              _.forEach(
                agent.listeMessages,
                (message, key) => {
                  // sur quel site à été envoyé ce mesage
                  if (message.siteID === site.LIC_ID) {
                    numMessage++
                  }
                }
              )
            }
          )
          // ajoute le nombre de message
          arraySite.push({
            'numMessage': numMessage,
            'url': site.LIC_URL,
            'id': site.LIC_ID
          })
        }
      )
      // recherche aussi les message facebook
      let messagefacebook = 0
      // pour chaque agent
      _.forEach(
        this.$store.state._User.colleagues,
        (agent, key) => {
          // pour chaque message
          _.forEach(
            agent.listeMessages,
            (message, key) => {
              // sur quel site à été envoyé ce mesage
              if (message.network === 'facebook') {
                messagefacebook++
              }
            }
          )
        }
      )

      // ajoute le nombre de message venant de facebook
      arraySite.push({
        'numMessage': messagefacebook,
        'url': 'facebook',
        'id': 'facebook'
      })
      // recherche aussi les message whatsapp
      let messagewhatsapp = 0
      // pour chaque agent
      _.forEach(
        this.$store.state._User.colleagues,
        (agent, key) => {
          // pour chaque message
          _.forEach(
            agent.listeMessages,
            (message, key) => {
              // sur quel site à été envoyé ce mesage
              if (message.network === 'whatsapp') {
                messagewhatsapp++
              }
            }
          )
        }
      )
      // ajoute le nombre de message venant de facebook
      arraySite.push({
        'numMessage': messagewhatsapp,
        'url': 'whatsapp',
        'id': 'whatsapp'
      })

      return arraySite
    },

    dataVisiteurComputed () {
      // console.log('dataVisiteurComputed')
      let visiteurDataSelected
      let index
      // console.log('this.messageAttenteSelected', this.messageAttenteSelected)
      // si le visiteur est en ligne
      if (!this.filterFront) {
        // console.log('visiteur online')
        index = _.findIndex(this.concatAllVisiteurs, {'visiteurID': this.messageAttenteSelected.visiteurID})
        // console.log('index 1 : ', index)
        if (index !== -1) {
          visiteurDataSelected = this.concatAllVisiteurs[index]
        }
        // visiteurDataSelected = _.find(this.concatAllVisiteurs, {'visiteurID': this.messageAttenteSelected})
      } else {
        // console.log('visiteur offline')
        // visiteurDataSelected = _.find(this.listeAllVisiteurs, {'visiteurID': this.messageAttenteSelected})
        index = _.findIndex(this.listeAllVisiteurs, {'visiteurID': this.messageAttenteSelected.visiteurID})
        // console.log('index 2 : ', index)
        if (index !== -1) {
          visiteurDataSelected = this.listeAllVisiteurs[index]
          visiteurDataSelected.histoChat = this.allDataVisiteurOpened.histoChat
        }
      }
      // console.log('index', index)
      if (index === -1) {
        // il faut recuperer le bon histoChat dans le store 'allDataVisiteurOpened'
        // c'est celui qui est mise à jour pour les messages visiteur offline en attente
        let MAJHistoCHat = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat)
        this.visiteurData.histoChat = MAJHistoCHat
        // c'est le visiteurDataSelected avec l'histoChat à jour pour les messages en attente
        visiteurDataSelected = this.visiteurData
      }
      // console.log('visiteurDataSelected', {'cobrowsing': false, 'online': true, 'viewStatus': true, 'visiteurDatas': visiteurDataSelected, 'visiteurID': this.messageAttenteSelected})
      return {'cobrowsing': false, 'online': true, 'viewStatus': true, 'visiteurDatas': visiteurDataSelected, 'visiteurID': this.messageAttenteSelected.visiteurID}
    }
  }
}
</script>

<style scoped>
 .messagingBubble {vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/components/trafic/Attente.vue